<!-- <p>add-level-permission works!</p> -->
<app-dialog-header headerIcon="lock" headerText="Add Permissions" (onCloseClick)="onCancelClick()"></app-dialog-header>
<form [formGroup]="dialogForm">
	<div mat-dialog-content style="max-width: 500px;">
		<mat-form-field appearance="fill" *ngIf="accountGroups">
			<mat-label>Permission Group <span *ngIf="loadingGroups">(Loading)</span> </mat-label>
			<mat-select formControlName="AccountGroupID" [disabled]="loadingGroups">
				<mat-option *ngFor="let Group of accountGroups"
					[value]="Group.AccountGroupID">{{Group.Name}}</mat-option>
			</mat-select>
		</mat-form-field>
		<div class="md-form mb-1 matFormSlider">
			<div formArrayName="Permissions">
				<div [formGroupName]="0">
					<mat-label>View</mat-label>
					<mat-checkbox #switchView formControlName="View" color="primary"></mat-checkbox>
					<mat-label>Write</mat-label>
					<mat-checkbox #switchWrite formControlName="Write" color="primary"></mat-checkbox>
				</div>
			</div>
		</div>
	</div>
	<div mat-dialog-actions>
		<button mat-button [mat-dialog-close]="dialogForm.value" 
			[disabled]="dialogForm.invalid || !dialogForm.dirty">Ok</button>
		<button mat-button (click)="onCancelClick()" cdkFocusInitial>Cancel</button>
	</div>
</form>
